<p-panel>
	<p-header>
		<h3>
			<span *ngIf="creator.nameprefix">{{creator.nameprefix}} </span>{{creator.creatorname}}<span *ngIf="creator.namesuffix"> {{creator.namesuffix}}</span>, {{creator.firstname}}
		</h3>
	</p-header>
	<div class="columnHalf">
        <p-panel header="{{ 'fs.res.publication.creators.organizations.choose.fieldset.title' | hisUi }}">
            <res-internal-organization-edit *ngIf="creator.person"
                [organizations]="internalOrganizations"
                [ddKey]="'fs.res.publication.PublicationHumanCreator.internalOrganization'"
                [isAddOrganization]="true"
                [showSelectionBelow]="false"
                [singleSelect]="false"
                [personId]="creator.person.id"
                [clearAfterSelection]="true"
                (selectedInternalOrgUnitChange)="selectInternalOrganization($event)">
            </res-internal-organization-edit>

            <res-historized-organization-edit *ngIf="creator.person"
                [organizations]="internalOrganizations"
                [ddKey]="'fs.res.publication.PublicationHumanCreator.historizedOrganization'"
                [isAddOrganization]="true"
                [showSelectionBelow]="false"
                [clearAfterSelection]="true"
                (selectedHistorizedOrgUnitChange)="selectInternalOrganization($event)">
            </res-historized-organization-edit>

            <res-external-organization-edit
                [organizations]="externalOrganizations"
                [ddKey]="'fs.res.publication.PublicationHumanCreator.externalOrganization'"
                [isAddOrganization]="true"
                [showCreateLink]="true"
                [singleSelect]="false"
                [showSelectionBelow]="false"
                [clearAfterSelection]="true"
                (selectedExternalOrgUnitChange)="selectExternalOrganization($event)"
                (createExternalOrgUnitChange)="createExternalOrgUnit()">
            </res-external-organization-edit>

           <res-external-organization-create-dialog *ngIf="externalOrgDialogVisible" [(visibility)]="externalOrgDialogVisible"
                (saveDialogChange)="saveDialogChange($event)">
            </res-external-organization-create-dialog>
        </p-panel>
	</div>
	<div class="columnHalf">
        <p-panel header="{{ 'fs.res.publication.creators.organizations.assigned.fieldset.title' | hisUi }}">
            <div class="infoMessage" [innerHTML]="'fs.res.publication.creators.organizations.sort.helptext' | hisUi"></div>
            <ul class="listSimple">
                <li *ngFor="let organization of creatorOrganizations; index as i">
                    <div class="columnHalf highlightedListItem color_pale_blue">
                        <ng-container *ngIf="organization.organization" >
                            {{organization.organization.text}}
                        </ng-container>
                        <ng-container *ngIf="organization.researchPartner">
                            {{organization.researchPartner.defaulttext}} (ext.)
                        </ng-container>
                    </div>
                    <div class="columnHalf">
                        
                        <button (click)="moveDown(organization)" 
                        *ngIf="organization.sortorder !== creatorOrganizations.length; else spaceholder" 
                        hisImage="ARROW_DOWN" 
                        class="icon" 
                        [title]="organization.researchPartner ? ('fs.res.publication.creators.moveDownOf' | hisUi:organization.researchPartner.defaulttext) : ('fs.res.publication.creators.moveDownOf' | hisUi:organization.organization.text)"></button>
                        
                        <button (click)="moveUp(organization)" 
                        *ngIf="organization.sortorder !== 1; else spaceholder" 
                        hisImage="ARROW_UP" 
                        class="icon" 
                        [title]="organization.researchPartner ? ('fs.res.publication.creators.moveUpOf' | hisUi:organization.researchPartner.defaulttext) : ('fs.res.publication.creators.moveUpOf' | hisUi:organization.organization.text)"></button>
                        
                        <button (click)="removeOrganization(organization)" 
                        hisImage="DELETE" class="icon" 
                        [title]="organization.researchPartner ? ('common.deleteOf' | hisUi:organization.researchPartner.defaulttext) : ('common.deleteOf' | hisUi:organization.organization.text)"></button>
                        
                        <ng-template #spaceholder>
                            <button disabled="true" hisImage="SPACER" class="icon"></button>
                        </ng-template>
                    </div>
                    <div class="clearer"></div>
                </li>
            </ul>
        </p-panel>
	</div>
	<div class="clearer"></div>
</p-panel>
